import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { AdminCohorts, AdminDemoData } from '@platform/client';
import { FormsInputDropdown, InputDropdownItem } from '@platform/components';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';

type NewDemoCohortFormData = {
  corporateClientId: string;
};

export const CreateDemoCohortModal = (props: { onClose: () => void }) => {
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const [successText, setSuccessText] = useState<string>();
  const { control, handleSubmit, formState } = useForm<NewDemoCohortFormData>({
    mode: 'onChange',
  });

  const { data: clientData } = AdminCohorts.useGetCohortClients();
  const clientDropdownItems: InputDropdownItem[] = (clientData?.clients || []).map((client) => ({
    text: client.name,
    textValue: client.id,
  }));

  const createCohortMutator = AdminDemoData.useCreateDemoCohort({
    mutation: {
      onMutate: () => setModalStage('submitting'),
      onError: () => setModalStage('error'),
      onSuccess: (data) => {
        setSuccessText(`Cohort #${data.cohortId} (${data.cohortName}) created.`);
        setModalStage('success');
      },
    },
  });

  const onSubmit: SubmitHandler<NewDemoCohortFormData> = (data) => {
    createCohortMutator.mutate({
      data: { corporateClientId: parseInt(data.corporateClientId) },
    });
  };

  return (
    <AdminFormModal
      title='Create Demo Cohort'
      onClose={props.onClose}
      modalStage={modalStage}
      successText={successText}
      submitCTA={{
        text: 'Create',
        callback: () => handleSubmit(onSubmit)(),
      }}
    >
      <div className='space-y-2'>
        <p className='text-sm text-gray-600'>
          Creates a new cohort with realistic placeholder details, ready to assign demo
          professionals or teams to.
        </p>
        <FormsInputDropdown
          type='default'
          control={control}
          name='corporateClientId'
          label='Corporate Client'
          items={clientDropdownItems}
          rules={{ required: 'Corporate client is required' }}
          error={formState.errors.corporateClientId}
          inputDisabled
        />
      </div>
    </AdminFormModal>
  );
};
